'use client';

import { useState } from 'react';
import Button, { ButtonVariants } from '@pixum/button';
import Text, { TEXT_VARIANT } from '@pixum/text';
import { Dialog, DialogContent, DialogFooter, DIALOG_ROLES } from '@pixum/web-dialog';
import { LinkWithMasking } from 'components';
import type { PhoneNumberHintProps } from '../../types';
import { trackPhoneDescriptionClick } from '../../../analytics/address';

/**
 * Displays an explanatory dialog for the phone number field.
 * @param props - Localized labels and explanatory text.
 * @returns A link that opens the phone-number explanation dialog.
 */
export function PhoneNumberHint({ constants }: PhoneNumberHintProps) {
  const [isOpen, setIsOpen] = useState(false);
  const headline = constants['i18n_why_phone_number_needed_headline'];
  const text = constants['i18n_why_phone_number_needed_text'];
  const okayLabel = constants['i18n_cart_action_ok'];

  return (
    <>
      <LinkWithMasking
        href="#phone-number-hint"
        masked={false}
        onClick={event => {
          event.preventDefault();
          trackPhoneDescriptionClick();
          setIsOpen(true);
        }}
      >
        {headline}
      </LinkWithMasking>
      <Dialog
        content={
          <DialogContent>
            <>
              <Text variant={TEXT_VARIANT.HEADLINE}>{headline}</Text>
              <Text>{text}</Text>
            </>
          </DialogContent>
        }
        footer={
          <DialogFooter
            right={
              <Button label={okayLabel} onClick={() => setIsOpen(false)} variant={ButtonVariants.TERTIARY}>
                {okayLabel}
              </Button>
            }
            role={DIALOG_ROLES.ALERT}
          />
        }
        onClose={() => setIsOpen(false)}
        open={isOpen}
        role={DIALOG_ROLES.ALERT}
        showCloseButton={false}
      />
    </>
  );
}
